module.exports = __webpack_public_path__ + "static/img/Dashu_Banner_autumn.297fd1f0.jpg";